import React from "react";

import { useTranslation } from "react-i18next";
import { truncateString } from "../../constants/AppMethod";

const AddressCard = (props) => {
    const { addressType, address, index, updateAddress, listLength } = props;
    const { t } = useTranslation(["translation"]);
    const truncateStrLength = ( addressType === "BILLING" ) ? 15 : 35;
    return (
        <React.Fragment>
            <div className={`row address-card ${addressType?.toLowerCase()} ${(listLength === 1) ? 'single-card' : 'more-cards'}`} key={index}>
                <div className="address-content">
                    {addressType !== 'BILLING' && <>
                        <div className="row">
                            <div className="col-10">
                                <div className="address-field-label">
                                    {t("MANAGE_ADDRESS.ADDRESS_FORM.DEVICE_SERIAL_NO")}
                                </div>
                                <div className="address-field-value"> {address?.serialNumber} </div>
                            </div>
                        </div> </>}
                    <div className="row">
                        <div className="col-10 mt-15">
                            <div className="address-field-label">
                                {t("MANAGE_ADDRESS.ADDRESS_FORM.LOCATION_NAME")}
                            </div>
                            <div className="address-field-value"> {address?.addressName || truncateString(address?.addressLine1, truncateStrLength)} </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-10 mt-15">
                            <div className="address-field-label">
                                {t("MANAGE_ADDRESS.ADDRESS_FORM.ADDRESS")}
                            </div>
                            <div className="address-field-value"> {address?.addressLine1} </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-10 mt-15">
                            <div className="address-field-label">
                                {t("MANAGE_ADDRESS.ADDRESS_FORM.ADDRESS")}
                            </div>
                            <div className="address-field-value"> {address?.addressLine2} </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-10 mt-15">
                            <div className="address-field-label">
                                {t("MANAGE_ADDRESS.ADDRESS_FORM.TOWN_CITY")}
                            </div>
                            <div className="address-field-value"> {address?.cityTown} </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5 mt-15">
                            <div className="address-field-label">
                                {t("MANAGE_ADDRESS.ADDRESS_FORM.COUNTRY")}
                            </div>
                            <div className="address-field-value"> {address?.country} </div>
                        </div>
                        <div className="col-4 mt-15 ml-9">
                            <div className="address-field-label">
                                {t("MANAGE_ADDRESS.ADDRESS_FORM.POSTCODE")}
                            </div>
                            <div className="address-field-value"> {address?.postCode} </div>
                        </div>
                    </div>
                </div>
                <div className="address-action">
                    <div className='row'>
                        <button className='address-update-btn' onClick={() => updateAddress(address)} >  {t("MANAGE_ADDRESS.UPDATE_ADDRESS")} </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddressCard;